module.exports = __webpack_public_path__ + "media/images/new-watermark-fc9f4018eab44613b116c9279499d55c.png";